import baseV3Service from './base/baseV3Service.js';

//  Organizations
const getOrganizations = (config) => {
    return baseV3Service.get("organizations", config);
};
const getOrganization = (organizationId, config) => {
    return baseV3Service.get(`organizations/${organizationId}`, config);
};
const updateOrganization = (organizationId, payload, config) => {
    return baseV3Service.put(`organizations/${organizationId}`, payload, config);
};
const createOrganization = (payload, config) => {
    return baseV3Service.post("organizations", payload, config);
};

export { createOrganization, getOrganization, getOrganizations, updateOrganization };
